import {Component, OnInit} from '@angular/core';
import {DocumentSigningService} from "../../_services/document-signing.service";
import {SessionService} from "../../_services/session.service";
import {Router} from "@angular/router";
import {AppConfig} from "../../app.config";
import {AuthenticactionService} from "../../_services/authentication.service";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss', '../../../assets/css/cu.css']
})
export class HomeComponent implements OnInit {
    private _mainLoad: boolean = false;
    constructor(
        private authService: AuthenticactionService,
        private documentSigningService: DocumentSigningService,
        private sessionService: SessionService,
        private router: Router
    ) {
    }

    async ngOnInit(): Promise<void> {
        this.mainLoad = false;
        await this.resetSession();
    }

    public async redirectClaveUnicaLogin() {
        this.mainLoad = true;
        this.getAuthForLogin().then(data => {
            if (data['status'] === 1) {
                this.authService.login2(data);
            } else {
                console.log('Se ha producido un error, por favor contacte a DTI.');
                this.mainLoad = false;
            }
        });
    }

    private async getAuthForLogin() {
        return await this.documentSigningService.getLogin();
    }

    private async resetSession(){
        await this.authService.logoutAll(false);
    }

    get mainLoad(): boolean {
        return this._mainLoad;
    }
    set mainLoad(value: boolean) {
        this._mainLoad = value;
    }
}
